Profiling.Sessions ||= {}

class Profiling.Sessions.View extends Backbone.View
  template: JST['backbone/templates/profiling/sessions/sessions']
  el: 'body'

  events :
    'click #new_session': '_addNewTab'
    'mouseleave li.session' : 'onMouseLeaveSession'

  initialize: ({sessions, topics, defaultCharts, availableChannelsByProvider, profileTags}) ->
    @topics = topics
    @defaultCharts = defaultCharts
    @availableChannelsByProvider = availableChannelsByProvider
    @sessions = sessions
    @profileTags = notNull(profileTags)
    @tabs = []
    @currentTabIndex = undefined
    @scrollingView = new Customer.Tabs.TabScrollingView()
    @eventAggregator.bind('clickOnTab', @_changeCurrentTab)
    @eventAggregator.bind('newTab', @_changeCurrentTab)
    @eventAggregator.bind('clickOnMinimizeTab', @_minimizeTab)
    @eventAggregator.bind('clickOnCloneDashboard', @_cloneDashboard)
    @eventAggregator.bind('clickOnRestoreSession', @_restoreSession)
    @eventAggregator.bind('clickOnRemoveSession', @_removeSession)
    @eventAggregator.bind('clickOnMinimizeAndRemoveSession', @_removeNewSession)
    @eventAggregator.bind('removeAllSessions', @_removeAllSessions)
    @eventAggregator.bind('sessionListChange', @_updateSessions)
    @eventAggregator.bind('replaceSession', @_replaceSession)
    @eventAggregator.bind('currentSessionNameObtained', @_finishRender)
    @eventAggregator.bind('addNewTab', @_addNewTab)

  render: (options = {}) ->
    defaultOptions = {
      cameFromModerationDashboard: false
    }
    options = $.extend({}, defaultOptions, options)

    @$el.find('#tabs').before(@template())
    @$el.find('#tabs-wrapper').append(@scrollingView.render().el)
    @scrollingView.setScrollableElement(@$el.find('#main-header #tabs'))

    for session in @sessions
      if not session.minimized
        @_addNewTabFromExistingSession(session, options, false)
    if @tabs.length != 0
      @_getCurrentSessionNameAndContinue()
      @$el.find('#content').find('.dashboard').hide()
    else
      @_addNewTab()
    @

  _getCurrentSessionNameAndContinue: =>
    $.ajax
      url: '/monitoring/sessions/current_session_of_user',
      type: 'GET',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) =>
        @eventAggregator.trigger('currentSessionNameObtained', response.current_session_name)

  _getSessionIndexFromName: (sessionName) ->
    sessionNames = @tabs.map( (session) -> session.name )
    sessionIndex = sessionNames.indexOf(sessionName)
    return sessionIndex

  _finishRender: (currentSessionName) =>
    currentSessionIndex = @_getSessionIndexFromName(currentSessionName)
    currentSessionIndex = 0 if currentSessionIndex < 0
    @_changeCurrentTab(@tabs[currentSessionIndex])

  _replaceSession: (searchQuery) =>
    uuid = searchQuery.get('uuid')
    @_cloneDashboard(searchQuery)
    @_destroyTab(@_searchExistingTabForSession(uuid))

  _cloneDashboard: (searchQuery) =>

  _addNewTab: (event) =>
    event.preventDefault() if event
    uuid = Monitoring.Models.RandomStringGenerator.generateNewUuid()
    dashboard = new Profiling.Dashboard.DashboardView({
      topics: @topics,
      uuid: uuid,
      availableChannelsByProvider: @availableChannelsByProvider,
      sessionList: @sessions,
      profileTags: @profileTags
    })
    @_addNewTabFromDashboard(dashboard)

  _addNewTabFromDashboard: (dashboard) ->
    sessionTab = new Profiling.Sessions.TabView(name: I18n.t('monitoring.dashboard.session.tab.placeholder'), dashboard: dashboard, sessionsView: this)
    sessionTab._renameTooltip(I18n.t('monitoring.dashboard.session.tab.placeholder'))
    @_bindEvents(dashboard, sessionTab)
    @_createNewTab(sessionTab)
    @_changeCurrentTab(sessionTab)

  _addNewTabFromExistingSession: (session, options = {}, loadTab) ->
    dashboard = new Profiling.Dashboard.DashboardView($.extend({}, options, {
      topics: @topics,
      session: session,
      availableChannelsByProvider: @availableChannelsByProvider,
      profileTags: @profileTags
    }))
    sessionTab = new Profiling.Sessions.TabView(name: session.name, dashboard: dashboard, sessionsView: this)
    sessionTab._renameTooltip(session.name)
    @_bindEvents(dashboard, sessionTab)
    @_createNewTab(sessionTab)
    return sessionTab

  _bindEvents: (dashboard, sessionTab) ->
    sessionTab._renameTooltip(sessionTab.name)
    dashboard.bind('firstSearch', sessionTab.setName, sessionTab)
    dashboard.bind('restoreFromServer', @_restoreFromServer)
    dashboard.bind('totalChanges', (total) => sessionTab.updateCount(total))

  _createNewTab: (sessionTab) ->
    @tabs.push(sessionTab)
    @$el.find('#tabs').append(sessionTab.render().el)
    # We must append the dashboard element before rendering it to get Chosen to work!
    @$el.find('#content').append(sessionTab.dashboard.el)
    sessionTab.dashboard.bind('destroyFromRestore', => @_destroyTab(sessionTab))
    sessionTab.dashboard.render()

  _changeCurrentTab: (sessionTab) =>
    for tab in @tabs
      tab.deactivate()
    @currentTabIndex = @tabs.indexOf(sessionTab)
    @_updateCurrentSession(sessionTab.name) if sessionTab.name != "New session"
    try
      @tabs[@currentTabIndex].activate()
      @showCurrentTab()
    catch error
      # happens when creating My History session when no other sessions exist
      # it is harmless, the only problem is visual and is fixed with the following line
      # $('li.session').addClass('active')
      console.log(error)
    @scrollingView.scrollTo(sessionTab.$el)

  _updateCurrentSession: (sessionName) =>
    # $.ajax
    #   url: '/monitoring/sessions/current_session_of_user',
    #   type: 'PUT',
    #   data: { current_session: sessionName }

  showCurrentTab: ->
    @$el.find('#content').find('.dashboard').hide()
    @tabs[@currentTabIndex].dashboard.$el.show()

  _minimizeTab: (sessionTabOrUuid, updateServer = true) =>
    sessionTab = if typeof sessionTabOrUuid is 'string'
      @_searchExistingTabForSession(sessionTabOrUuid)
    else
      sessionTabOrUuid
    @_minimize(sessionTab.getUuid()) if updateServer
    @_destroyTab sessionTab

  _destroyTab: (sessionTab) ->
    sessionTabIndex = @tabs.indexOf(sessionTab)
    currentActiveTab = @tabs[@currentTabIndex]
    @tabs.splice(sessionTabIndex, 1);
    if @tabs.length == 0
      @_addNewTab()
      @currentTabIndex = undefined
    else
      if sessionTab == currentActiveTab
         @currentTabIndex = if @currentTabIndex == 0 then @currentTabIndex else @currentTabIndex - 1
         @tabs[@currentTabIndex].activate()
         @showCurrentTab()
      else
        @currentTabIndex = @tabs.indexOf(currentActiveTab)

    sessionTab.destroy()

  _minimize:(uuid) ->
    $.ajax
      url: '/profiling/minimize_session',
      type: 'POST',
      data: { session_id: uuid}

  _searchExistingTabForSession: (uuid) ->
    _.find @tabs, (tab) ->
      tab.getUuid() == uuid

  _removeSession: (session) =>
    tab = @_searchExistingTabForSession session.id
    if tab
      @_destroyTab tab
    $.ajax
      url: "/profiling/delete_session",
      type: 'DELETE',
      data: { session_id: session.id}
      success: =>
        @eventAggregator.trigger('sessionListChange')

  _removeAllSessions: =>
    # )

  _removeNewSession: (session_tab) =>
    @_removeSession(session_tab.session())

  _restoreSession: (session, callback) =>
    tab = @_searchExistingTabForSession session.id
    if tab
      @_changeCurrentTab tab
    else
      sessionTab = @_addNewTabFromExistingSession session
      @_changeCurrentTab sessionTab
    callback()

  _restoreFromServer: (dashboard) ->

  _updateSessions: =>
    $.ajax
      url: '/profiling/get_sessions',
      type: 'get',
      dataType: 'json',
      success: (response) =>
        if response.sessions?
          @sessions = response.sessions
          for tab in @tabs
            tab.dashboard.updateSessionList @sessions

  onMouseLeaveSession: (event) ->
    event.stopPropagation()
    $(event.target).find('.dropdown').removeClass('open')
